// services/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyAWr_pl7YNrt5xhnuygePpTDsfULRE8QT4",
    authDomain: "portfolio-app-e962f.firebaseapp.com",
    projectId: "portfolio-app-e962f",
    storageBucket: "portfolio-app-e962f.firebasestorage.app",
    messagingSenderId: "264372524892",
    appId: "1:264372524892:web:c0ad1fd76563e1915c5399",
    measurementId: "G-Q0YRM6DJGR"
};

// Firebaseアプリの初期化
const app = initializeApp(firebaseConfig);
// Firestoreデータベースを初期化
export const db = getFirestore(app);

export const auth = getAuth(app); // 認証用

